export default __webpack_public_path__ + "static/media/man.0b5d3e58.svg";